export default "__VITE_ASSET__DDnFkcit__"